// extracted by mini-css-extract-plugin
module.exports = {"financialRisksNotice":"FinancialRisksNotice_financialRisksNotice__fykL9"};